export const reports = {
  classDropDown: 'classDropDown',
  schoolDropDown: 'schoolDropDown',
  studentDropDown: 'studentDropDown',
  teacherDropDown: 'teacherDropDown',
};
